// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ZnUrn","title":"styles_title__sg5o7","info":"styles_info__Tzbvu","button":"styles_button__Bn8xs"};